import React from 'react'

// redux
import { useSelector, useDispatch } from 'react-redux'
import { getDisplayOptions, getShowWeather } from '../redux/options/selectors' 
import { setOption } from '../redux/options/actions' 

// components
import LabeledToggle from './LabeledToggle'

const DisplayOptions = () => {

  // get notify options  
  const display = useSelector( getDisplayOptions )
  const weather = useSelector( getShowWeather )

  // dispatcher
  const dispatch = useDispatch()
  const changeOption = ( key, value ) =>
  {

    dispatch( setOption( key, value, 'display' ) )
  }

  // change toggle option
  const onToggle = ( key, value ) => 
  {    
    // change option
    changeOption( key, value ) 
  }

  return (
    <div className="display">

      <LabeledToggle 
        onChange={ onToggle } 
        checked={ display.summary } 
        name="summary">Show summary</LabeledToggle>

      <LabeledToggle 
        onChange={ onToggle } 
        checked={ display.day_graph } 
        name="day_graph">Show day times graph</LabeledToggle>

      <LabeledToggle 
        onChange={ onToggle } 
        checked={ display.position_graph } 
        name="position_graph">Show group graph</LabeledToggle>

      <LabeledToggle 
        onChange={ onToggle } 
        checked={ display.time_graph } 
        name="time_graph">Show car time graph</LabeledToggle>

      <LabeledToggle 
        onChange={ onToggle } 
        checked={ weather } 
        name="weather">Show weather</LabeledToggle>

    </div>

  )
}

export default DisplayOptions